import GlobalSearch from '../global-search';
import { debounce  } from 'throttle-debounce';

export default class SearchBar extends GlobalSearch {
    constructor(block){
        super();
        
        // Set variables and context outside of loop
        let _t                = this;
        this.config.container = block;

        this.config.container.each(function(i, search){
            let $search = $(search);
            let type    = $search.data('search-type');

            if(type == 'global' || type == 'course' || type == 'study'){
                $(this).attr('data-search-bar', i);
                _t.eventHandlers($search, i);
            }
        });
    }

    eventHandlers(search, number)
    {   
        let _t              = this;
        let form            = search.find('form.search-form');
        let search_input    = search.find('input[type="search"]');
        let search_clear    = search.find('.search-clear');
        let search_results  = search.find('.search-results');
        let active_facet    = (search.data('search-type') == 'course' || search.data('search-type') == 'study') ? 'Courses' : '';
        let previous_query  = null;

        form.append(`<ul class="search-results"></ul>`);

        search_results  = search.find('.search-results');

        $(form).on('submit', function(e){
            e.preventDefault();

            let query = $(search_input).val();

            // Check if search input isnt empty and the search query doesn't match the previous query
            if (query.trim().length > 0) $(this)[0].submit();
        });

        // Typing Behaviours for Search Input
        $(search_input).on('keyup', debounce(this.config.delay, function() {
            let query = $(this).val();

            search_results.hide();
            
            if(query.trim().length > 0 && query !== previous_query){
                previous_query = query;
                search_clear.addClass('active');
                _t.getSearchResults(query, active_facet, search_results, search_input, form);
            } else {
                previous_query = '';
                search_clear.removeClass('active');
            }
        }));

        // Search Dropdown Behaviour When Typing and Clicking In Search Input
        $(search_input).on('click', function() {
            let query = $(this).val();

            $(search_results).show();

            if(query.trim().length > 0 && search_results.children().length > 0 && !search_clear.hasClass('active')) search_clear.addClass('active');
            
            if(query.trim().length === 0 && search_results.children().length > 0) search_results.empty();
        });

        // Click Behaviour Outside of Search Dropdown and Search Imput
        $(document).on('click', function(e) {
            let $target = $(e.target);

            if (!$target.is(search_input) && !$target.closest(search_results).length) {
                $(search_results).hide();
            }
        });

        // Update Search Input Query When Suggested Text Clicked
        $(document).on('click',  'mimas-block[data-search-bar="'+number+'"] a.result', function(e) {
            e.preventDefault();

            let query = ($(this).hasClass('suggestion')) ? $(this).find('.highlight').text() : $(this).find('.text').text();

            $(search_input).val(query);
            $(search_results).hide();

            if($('mimas-block[data-search-bar="'+number+'"]').data('search-type') === 'global'){

                let facet   = $(this).find('.type').text();
                let action  = form.attr('action');

                facet = (facet.length > 0) ? facet.toLowerCase() : '';

                // Change form action query
                form.attr('action', action + '/' + facet);
            }
            
            $(form)[0].submit();
        });

        // Clear Search Input and Results
        $(search_clear).on('click', function() {
            $(this).removeClass('active');

            $(search_results).hide();
            $(search_results).empty();
            $(search_input).val('');

            previous_query = '';
        });
    }

    // Fetches Data From WP Query Endpoint /wp-json/mimas/v1/elastic
    fetchAPI(endpoint, params = {}, input, form) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: Object.keys(params).length 
                    ? `${endpoint}?${$.param(params)}`
                    : endpoint,
                method: 'GET',
                beforeSend: () => {
                    form.addClass('loading');
                },
                complete: () => {
                   form.removeClass('loading');
                },
                success: (response) => {
                    resolve(response);
                },
                error: (err) => {
                    reject(err);
                }
            });
        });
    }

    cleanSearchTitle($title){
        $title.replace(/<[^>]*>/g, ' ') // Remove HTML tags (like <br />, <p>, etc.)
              .replace(/&[#\w]+;/g, ' ') // Remove HTML entities
              .replace(/[^\w\s-]/g, ' ') // Remove special characters except dash
              .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
              .trim();

        return $title;
    }

    // Renders the HTML for the Search Suggestion Item (Did you mean?)
    renderSearchSuggestion(suggestion, search_results)
    {
        let _t = this;

        let html = this.config.template
            .replaceAll('{{className}}', 'suggestion' || '')
            .replaceAll('{{link}}', '#' || '')
            .replaceAll('{{text}}', 'Did you mean <div class="highlight">' + suggestion + '</div>' || '')
            .replaceAll('{{type}}', 'Suggestion');

        let $resultItem = $(html);

       search_results.append($resultItem);
    }

    // Renders the HTML for the Search No Results Item
    renderSearchNoResults(query, search_results)
    {
        let _t = this;

        let html = this.config.template
            .replaceAll('{{className}}', 'no-results' || '')
            .replaceAll('{{link}}', '#' || '')
            .replaceAll('{{text}}', 'No results for <div class="highlight">' + query + '</div>' || '')
            .replaceAll('{{type}}', 'No results');

        let $resultItem = $(html);

       search_results.append($resultItem);
    }

    // Render Search Results For Different Result Types
    renderSearchResults(results, search_results)
    {
        let _t = this;

        $.each(results, (index, result) => {
            let text    = _t.cleanSearchTitle(result.highlight.search_as_you_type[0]) ?? '';
            let type    = result._source.search_tab ?? '';

            let html = _t.config.template
                .replaceAll('{{className}}', type.toLowerCase())
                .replaceAll('{{link}}', '#' || '')
                .replaceAll('{{text}}', text)
                .replaceAll('{{type}}', type);

            search_results.append(html);
        });
    }

    generateSearchBody(query, facet)
    {
        return {
            'query': query,
            'facet': facet
        }
    }

    getSearchResults(query, facet, search_results, search_input, form)
    {
        let _t              = this;
        this.config.body    = this.generateSearchBody(query, facet);

        _t.fetchAPI(this.config.endpoint, this.config.body, search_input, form)
        .then(response => {
            search_results.empty();
            search_results.show();

            // Check if response has no suggestion and no results
            if(response.suggest.did_you_mean[0].options.length == 0 && response.hits.hits.length == 0) _t.renderSearchNoResults(query, search_results);

            // Check if response has a suggestion
            if(response.suggest.did_you_mean[0].options.length > 0) _t.renderSearchSuggestion(response.suggest.did_you_mean[0].options[0].text, search_results);

            // Check if response has results
            if(response.hits.hits.length > 0) _t.renderSearchResults(response.hits.hits, search_results);
        })
        .catch(err => {
            console.log(err);
        });
    }
}

(function ($) {
    $(document).ready(function () {
        let $search_bar = $('mimas-block[block-name="search-bar"]');

        if($search_bar.length) new SearchBar($search_bar);
    });
})(jQuery);